import { createContext, type ReactElement, useEffect, useState } from "react";
import { type CurrentUser } from "../api/types";
import { CenterSpinner } from "../atoms/spinner";
import { getCurrentUser } from "../api/v2/requests";

interface ContextState {
  user?: CurrentUser;
  setUser: (value?: CurrentUser) => void;
}

export const AuthContext = createContext<ContextState | undefined>(undefined);

interface Props {
  children: ReactElement | ReactElement[];
}

export const AuthProvider = ({ children }: Props) => {
  const [user, setUser] = useState<CurrentUser | undefined>();
  const [isRefreshing, setIsRefreshing] = useState(true);

  useEffect(() => {
    const loadCurrentUser = async () => {
      try {
        const data = await getCurrentUser();
        setUser(data);
      } catch {
        // handle no user below
      } finally {
        setIsRefreshing(false);
      }
    };

    if (!user && isRefreshing) {
      void loadCurrentUser();
    } else {
      setIsRefreshing(false);
    }
  }, [user, isRefreshing, setUser]);

  if (isRefreshing) {
    return <CenterSpinner withText />;
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
